import AppLayout from '../layout/AppLayout';
import AuthLayout from '../layout/AuthLayout';

interface IProps {
  token: string;
}

const LayoutRoute = ({ token }: IProps) => {
  if (token) return <AppLayout />;
  return <AuthLayout />;
};

export default LayoutRoute;
